import request from '@/utils/request'
import { getParameter } from '@/components/library/params'

/**
 * 获取菜单栏
 */
export const findMenus = () => {
  return request('/apps/findMenus', 'post', getParameter({ param: 'ROOT_PORTAL' }))
}

/**
 * 待办
 */
export const queryMenuCount = params => {
  return request('/webapi/notification/count', 'post', params)
}
